"use strict";
/* eslint-disable require-atomic-updates */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addSpinToStats = exports.combineStats = void 0;
// @TODO add rounding for the values with a precision of 2 (old TODO)
const constants_1 = require("../constants");
const object_1 = require("../object");
const bet_1 = require("./bet");
const math_1 = require("./math");
function combineStats(stats) {
    const firstItemDeepCloned = (0, object_1.deepCopy)(stats[0]);
    const combinedStats = stats.slice(1).reduce((combined, item) => {
        combined.raw.totalSpins += item.raw.totalSpins;
        combined.raw.sumBet += item.raw.sumBet;
        combined.raw.sumEURBet += item.raw.sumEURBet;
        combined.raw.sumWin += item.raw.sumWin;
        combined.raw.sumEURWin += item.raw.sumEURWin;
        combined.raw.winRatioSum += item.raw.winRatioSum;
        combined.raw.winRatioSquaresSum += item.raw.winRatioSquaresSum;
        combined.raw.sumRTP += item.raw.sumRTP;
        combined.raw.totalWins += item.raw.totalWins;
        if (!combined.raw.bestRTP || (item.raw.bestRTP && combined.raw.bestRTP < item.raw.bestRTP)) {
            combined.raw.bestRTP = item.raw.bestRTP;
        }
        combined.raw.bonusTotalSpins += item.raw.bonusTotalSpins;
        combined.raw.bonusSumWin += item.raw.bonusSumWin;
        combined.raw.bonusSumEURWin += item.raw.bonusSumEURWin;
        combined.raw.bonusSumBet += item.raw.bonusSumBet;
        combined.raw.bonusSumEURBet += item.raw.bonusSumEURBet;
        combined.raw.bonusWinRatioSum += item.raw.bonusWinRatioSum;
        combined.raw.bonusWinRatioSquaresSum += item.raw.bonusWinRatioSquaresSum;
        combined.raw.baseTotalSpins += item.raw.baseTotalSpins;
        combined.raw.spinsSinceLastBonus = Math.min(combined.raw.spinsSinceLastBonus, item.raw.spinsSinceLastBonus);
        combined.raw.baseSumWin += item.raw.baseSumWin;
        combined.raw.baseSumEURWin += item.raw.baseSumEURWin;
        combined.raw.baseSumBet += item.raw.baseSumBet;
        combined.raw.baseSumEURBet += item.raw.baseSumEURBet;
        combined.raw.baseWinRatioSum += item.raw.baseWinRatioSum;
        combined.raw.baseWinRatioSquaresSum += item.raw.baseWinRatioSquaresSum;
        combined.wins.best.win = Math.max(combined.wins.best.win || 0, item.wins.best.win || 0);
        combined.wins.best.winEUR = Math.max(combined.wins.best.win || 0, item.wins.best.winEUR || 0);
        return combined;
    }, firstItemDeepCloned);
    const raw = combinedStats.raw;
    combinedStats.totalSpins = raw.totalSpins;
    combinedStats.RTP = (0, math_1.getRTP)(raw.sumEURWin, raw.sumEURBet);
    combinedStats.SRP = (0, math_1.getSRP)(raw.sumRTP, raw.totalSpins);
    combinedStats.PL = (0, math_1.getPL)(raw.sumEURBet, raw.sumEURWin);
    combinedStats.stddev = (0, math_1.getStandardDeviation)(raw.winRatioSum, raw.winRatioSquaresSum, raw.totalSpins);
    combinedStats.wins.freq = (0, math_1.getFrequency)(raw.totalWins, raw.totalSpins);
    combinedStats.wins.stddev = (0, math_1.getStandardDeviation)(raw.winRatioSum, raw.winRatioSquaresSum, raw.totalSpins);
    combinedStats.wins.best.RTP = raw.bestRTP;
    combinedStats.bonus.freq = (0, math_1.getFrequency)(raw.bonusTotalSpins, raw.totalSpins); // @TODO default 0 in community (old comment)
    combinedStats.bonus.stddev = (0, math_1.getStandardDeviation)(raw.bonusWinRatioSum, raw.bonusWinRatioSquaresSum, raw.bonusTotalSpins);
    combinedStats.bonus.avg.RTP = (0, math_1.getPercentage)(raw.bonusSumEURWin, raw.bonusSumEURBet);
    combinedStats.base.stddev = (0, math_1.getStandardDeviation)(raw.baseWinRatioSum, raw.baseWinRatioSquaresSum, raw.baseTotalSpins);
    combinedStats.wagering = combinedStats.stddev / (((combinedStats.SRP / constants_1.HUNDRED_PERCENT)
        / ((combinedStats.base.stddev * (1 - (raw.bonusTotalSpins / raw.totalSpins)))
            + (combinedStats.bonus.stddev * (raw.bonusTotalSpins / raw.totalSpins)))) + ((combinedStats.SRP / constants_1.HUNDRED_PERCENT) / constants_1.MAGIC_WAGERING_COEFFICIENT));
    return combinedStats;
}
exports.combineStats = combineStats;
function addSpinToStatsRaw(gameId, statsRaw, spin, betLineLoader, currencyConverter, bonusChecker) {
    return __awaiter(this, void 0, void 0, function* () {
        const spinWin = spin.request.body.total_win;
        const spinBet = yield (0, bet_1.getTotalBet)(gameId, spin.request.body, betLineLoader);
        const currency = spin.request.body.currency.toUpperCase();
        let dateString = spin.date.toString();
        if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}:\d{3}$/.test(dateString)) {
            dateString = dateString.replace(/:\d{3}$/, '');
        }
        const dateInst = new Date(dateString);
        if (isNaN(dateInst.getTime())) {
            throw new Error(`Invalid date detected "${spin.date}"`);
        }
        const spinTotalWinEur = yield currencyConverter.convertToEurFrom(currency, spinWin, dateInst);
        const spinTotalBetEur = yield currencyConverter.convertToEurFrom(currency, spinBet, dateInst);
        const spinRtp = (0, math_1.getRTP)(spinWin, spinBet);
        const spinIsBonus = yield bonusChecker.isBonusSpin(gameId, spin.request.body.features);
        statsRaw.totalSpins++;
        statsRaw.lastSpinWin = spinWin;
        statsRaw.lastSpinWinEUR = spinTotalWinEur;
        statsRaw.sumBet += spinBet;
        statsRaw.sumEURBet += spinTotalBetEur;
        statsRaw.sumWin += spinWin;
        statsRaw.sumEURWin += spinTotalWinEur;
        statsRaw.winRatioSum += spinWin / spinBet;
        statsRaw.winRatioSquaresSum += Math.pow((spinWin / spinBet), constants_1.SQUARE_POWER);
        statsRaw.sumRTP += spinRtp;
        if (!statsRaw.bestRTP || spinRtp > statsRaw.bestRTP) {
            statsRaw.bestRTP = spinRtp;
        }
        if (spinWin > 0) {
            statsRaw.totalWins++;
        }
        if (spinIsBonus) {
            statsRaw.bonusTotalSpins++;
            statsRaw.spinsSinceLastBonus = 0;
            statsRaw.bonusSumWin += spinWin;
            statsRaw.bonusSumEURWin += spinTotalWinEur;
            statsRaw.bonusSumBet += spinBet;
            statsRaw.bonusSumEURBet += spinTotalBetEur;
            statsRaw.bonusWinRatioSum += spinWin / spinBet;
            statsRaw.bonusWinRatioSquaresSum += Math.pow((spinWin / spinBet), constants_1.SQUARE_POWER);
        }
        else {
            statsRaw.baseTotalSpins++;
            statsRaw.spinsSinceLastBonus++;
            statsRaw.baseSumWin += spinWin;
            statsRaw.baseSumEURWin += spinTotalWinEur;
            statsRaw.baseSumBet += spinBet;
            statsRaw.baseSumEURBet += spinTotalBetEur;
            statsRaw.baseWinRatioSum += spinWin / spinBet;
            statsRaw.baseWinRatioSquaresSum += Math.pow((spinWin / spinBet), constants_1.SQUARE_POWER);
        }
    });
}
function addSpinToStats(gameId, stats, spin, betLineLoader, currencyConverter, bonusChecker) {
    return __awaiter(this, void 0, void 0, function* () {
        const raw = stats.raw;
        yield addSpinToStatsRaw(gameId, raw, spin, betLineLoader, currencyConverter, bonusChecker);
        stats.totalSpins = raw.totalSpins;
        stats.RTP = (0, math_1.getRTP)(raw.sumEURWin, raw.sumEURBet);
        stats.SRP = (0, math_1.getSRP)(raw.sumRTP, raw.totalSpins);
        stats.PL = (0, math_1.getPL)(raw.sumEURBet, raw.sumEURWin);
        stats.stddev = (0, math_1.getStandardDeviation)(raw.winRatioSum, raw.winRatioSquaresSum, raw.totalSpins);
        stats.wins = {
            freq: (0, math_1.getFrequency)(raw.totalWins, raw.totalSpins),
            stddev: (0, math_1.getStandardDeviation)(raw.winRatioSum, raw.winRatioSquaresSum, raw.totalSpins),
            best: {
                RTP: raw.bestRTP,
                win: Math.max(raw.lastSpinWin, stats.wins.best.win || 0),
                winEUR: Math.max(raw.lastSpinWinEUR, stats.wins.best.winEUR || 0),
            },
        };
        stats.bonus = {
            freq: (0, math_1.getFrequency)(raw.bonusTotalSpins, raw.totalSpins),
            stddev: (0, math_1.getStandardDeviation)(raw.bonusWinRatioSum, raw.bonusWinRatioSquaresSum, raw.bonusTotalSpins),
            avg: {
                RTP: (0, math_1.getPercentage)(raw.bonusSumEURWin, raw.bonusSumEURBet),
            },
        };
        stats.base = {
            stddev: (0, math_1.getStandardDeviation)(raw.baseWinRatioSum, raw.baseWinRatioSquaresSum, raw.baseTotalSpins),
        };
        stats.wagering = stats.stddev / (((stats.SRP / constants_1.HUNDRED_PERCENT)
            / ((stats.base.stddev * (1 - (raw.bonusTotalSpins / stats.totalSpins)))
                + (stats.bonus.stddev * (raw.bonusTotalSpins / stats.totalSpins))))
            + ((stats.SRP / constants_1.HUNDRED_PERCENT) / constants_1.MAGIC_WAGERING_COEFFICIENT));
        return stats;
    });
}
exports.addSpinToStats = addSpinToStats;
